import React from 'react';
import ServiceArea from '../components/home/ServiceArea';
import FinalCTA from '../components/home/FinalCTA';

const ServiceAreaPage: React.FC = () => {
  return (
    <main className="pt-20">
      <div className="bg-brand-navy py-24 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-black mb-6">Service Area</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto">
            Proudly serving the residential communities of Jersey City and Hoboken.
          </p>
        </div>
      </div>
      <ServiceArea />
      <div className="py-24 bg-brand-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <h2 className="text-3xl font-black text-brand-navy">Local Expertise, Local Pride</h2>
            <p className="text-lg text-brand-navy/70 leading-relaxed">
              As an American Owned & Operated business based right here in Hudson County, we understand the unique 
              needs of our local residents. From the historic brownstones of Downtown Jersey City to the modern 
              high-rises of the Hoboken waterfront, we know how to clean your specific type of home.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {["Downtown JC", "The Heights", "Journal Square", "Bergen-Lafayette", "Hoboken North", "Hoboken South", "West Side", "Waterfront"].map((area, i) => (
                <div key={i} className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 font-bold text-brand-navy text-sm">
                  {area}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <FinalCTA />
    </main>
  );
};

export default ServiceAreaPage;
